import { postUrl } from '@/apiCalls/fetch';

export type IGetPlaceIdResponse = {
    result: {
        geometry: {
            location: {
                lat: number;
                lng: number;
            };
        };
    };
};

export async function getPlaceId(
    placeId: string
): Promise<IGetPlaceIdResponse> {
    const url = `/api/google/getPlaceId`;
    const response = await postUrl<IGetPlaceIdResponse>(url, {
        placeId,
    });
    return response;
}
